import { useEffect, useState } from "react"
import { useAppCalendar } from "hooks/calendar/useAppCalendar"
import dayjs from "dayjs"
import { HttpError, useList } from "@refinedev/core"
import { calendar_v3 } from "googleapis"
import { HELPS_POPUP_REFRESH_INTERVAL_MS, HELPS_EMERGENCY_TIME_TEST_MINUTES } from "core/helps/definitions"
import { EventCode, searchMetadataString } from "core/calendar/definitions"

export const useIsInEmergency = () => {
    const calendarId = useAppCalendar()
    const [date, setDate] = useState(dayjs())

    useEffect(() => {
        const t = setInterval(() => {
            setDate(dayjs())
        }, HELPS_POPUP_REFRESH_INTERVAL_MS)

        return () => {
            clearInterval(t)
        }
    }, [])

    const {
        data: events,
        ...rest
    } = useList<calendar_v3.Schema$Event, HttpError, calendar_v3.Schema$Event>({
        dataProviderName: 'gapi',
        resource: `calendar/calendars/:calendar/events`,
        meta: {
            params: {
                calendar: calendarId?.appointments
            }
        },
        queryOptions: {
            enabled: !!calendarId,
            refetchInterval: HELPS_POPUP_REFRESH_INTERVAL_MS
        },
        sorters: [
            {
                field: 'startTime',
                order: 'asc'
            }
        ],
        pagination: {
            pageSize: 1,
        },
        filters: [
            {
                field: 'timeMin',
                operator: 'eq',
                value: date.subtract(HELPS_EMERGENCY_TIME_TEST_MINUTES, 'minutes').toISOString()
            },
            {
                field: 'showDeleted',
                operator: 'eq',
                value: false
            },
            {
                field: 'singleEvents',
                operator: 'eq',
                value: true
            },
            {
                field: 'q',
                operator: 'eq',
                value: searchMetadataString({ code: EventCode.EMERGENCY_CALL })
            }
        ]
    })

    // logger.debug(events)
    const event = events?.data?.[0]

    return { event, ...rest }
}